import React, { useContext } from 'react'
import './CartItem.css'
import { ShopContext } from '../../Context/ShopContext'
import remove_icon from '../Assets/cart_cross_icon.png'
const CartItem = () => {
    const { All_product,get_total_cart_ammount, cartitem, remove_to_cart } = useContext(ShopContext);
    if(All_product.length<=0){
        return <>server is down data..</>;
    }
    return (
        <div className='cartitem'>
            <div className="cartitem-format-main">
                <p>Product</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>
            <hr />
            {All_product.map((e) => {
                if (cartitem[e.id] > 0) {
                  return <div>  <div className="cartitem-format cartitem-format-main">
                        <img src={e.image} className='cartitem-product-icon' />
                        <p>{e.name}</p>
                        <p>${e.new_price}</p>
                        <button className='cartitem-quantity'>{cartitem[e.id]}</button>
                        <p>${e.new_price*cartitem[e.id]}</p>
                        <img className='cartitem-remove-icon' src={remove_icon} onClick={() => { remove_to_cart(e.id) }} />
                        </div>
                        <hr />
                    </div>
                }
                return null;
            })}
            <div className="cartitem-down">
                <div className="cartitem-total">
                    <h1>Cart Total</h1>
                <div>
                    <div className="cartitem-total-items">
                        <p>Subtotal</p>
                        <p>${get_total_cart_ammount()}</p>                        
                    </div>
                    <hr />
                    <div className="cartitem-total-items">
                        <p>Shipping Free</p>
                        <p>Free</p>
                    </div>
                    <hr />
                    <div className="cartitem-total-items">
                        <h3>Total</h3>
                        <h3>${get_total_cart_ammount()}</h3>
                    </div>
                </div>
                <button>PROCEED TO CHECKOUT</button>
            </div>
            <div className="cartitem-promo-code">
                <p>If you have any promocode, Enter here</p>
                <div className="cartitem-promo-box">
                    <input type="text" placeholder='Promo Code' />
                    <button >Submit</button>
                </div>
            </div>
            </div>
        </div>
    )
}

export default CartItem
